export interface INotApplicableCriteria {
  displayName: string;
  criteriaName: string;
}

export class NotApplicableCriteriaModel implements INotApplicableCriteria {
  displayName: string = '';
  criteriaName: string = '';

  constructor(data?: INotApplicableCriteria) {
    if (data) {
      this.displayName = data?.displayName;
      this.criteriaName = data.criteriaName;
    }
  }
}
